webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mapdemo_mapHome__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mapdemo_mapHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mapdemo_mapHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mapdemo_mapGaode__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mapdemo_mapGaode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_mapdemo_mapGaode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mapdemo_mapGoogle__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mapdemo_mapGoogle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mapdemo_mapGoogle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mapdemo_mapTencent__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mapdemo_mapTencent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_mapdemo_mapTencent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mapdemo_mapOpenStreet__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mapdemo_mapOpenStreet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_mapdemo_mapOpenStreet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mapdemo_mapUseView__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mapdemo_mapUseView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_mapdemo_mapUseView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mapdemo_mapUseTangram__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mapdemo_mapUseTangram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_mapdemo_mapUseTangram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mapdemo_mapUseOpenlayer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mapdemo_mapUseOpenlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_mapdemo_mapUseOpenlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mapdemo_mapOsmbuildings__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mapdemo_mapOsmbuildings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mapdemo_mapOsmbuildings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_iview__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css__);













 // 使用 CSS

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_iview___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/mapview',
    name: 'mapHome',
    component: __WEBPACK_IMPORTED_MODULE_3__components_mapdemo_mapHome___default.a
  }, {
    path: '/mapview/openstreet',
    name: 'mapOpenStreet',
    component: __WEBPACK_IMPORTED_MODULE_7__components_mapdemo_mapOpenStreet___default.a
  }, {
    path: '/mapview/amap',
    name: 'mapGaode',
    component: __WEBPACK_IMPORTED_MODULE_4__components_mapdemo_mapGaode___default.a
  }, {
    path: '/mapview/google',
    name: 'mapGoogle',
    component: __WEBPACK_IMPORTED_MODULE_5__components_mapdemo_mapGoogle___default.a
  }, {
    path: '/mapview/tencent',
    name: 'mapTencent',
    component: __WEBPACK_IMPORTED_MODULE_6__components_mapdemo_mapTencent___default.a
  }, {
    path: '/mapview/map',
    name: 'mapUseView',
    component: __WEBPACK_IMPORTED_MODULE_8__components_mapdemo_mapUseView___default.a
  }, {
    path: '/mapview/tangram',
    name: 'mapUseTangram',
    component: __WEBPACK_IMPORTED_MODULE_9__components_mapdemo_mapUseTangram___default.a
  }, {
    path: '/mapview/openlayer',
    name: 'mapUseOpenlayer',
    component: __WEBPACK_IMPORTED_MODULE_10__components_mapdemo_mapUseOpenlayer___default.a
  }, {
    path: '/mapview/mapOsmbuildings',
    name: 'mapOsmbuildings',
    component: __WEBPACK_IMPORTED_MODULE_11__components_mapdemo_mapOsmbuildings___default.a
  }]
}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(66),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      columns1: 0,
      columns2: 0
    };
  },

  computed: {},
  mounted: function mounted() {
    this.init();
    this.initHttpQuest();
  },

  watch: {},
  methods: {
    // 初始化
    init: function init() {
      this.$Notice.destroy();
      this.$Notice.open({
        title: 'ฅ^•ﻌ•^ฅ',
        desc: '铿锵侠的主页&试验田',
        duration: 0
      });
      document.addEventListener('touchmove', function (e) {
        e.preventDefault();
      });
      var c = document.getElementsByTagName('canvas')[0],
          x = c.getContext('2d'),
          pr = window.devicePixelRatio || 1,
          w = window.innerWidth,
          h = window.innerHeight,
          f = 90,
          q,
          m = Math,
          r = 0,
          u = m.PI * 2,
          v = m.cos,
          z = m.random;
      c.width = w * pr;
      c.height = h * pr;
      x.scale(pr, pr);
      x.globalAlpha = 0.6;

      function i() {
        x.clearRect(0, 0, w, h);
        q = [{
          x: 0,
          y: h * .7 + f
        }, {
          x: 0,
          y: h * .7 - f
        }];
        while (q[1].x < w + f) {
          d(q[0], q[1]);
        }
      }

      function d(i, j) {
        x.beginPath();
        x.moveTo(i.x, i.y);
        x.lineTo(j.x, j.y);
        var k = j.x + (z() * 2 - 0.25) * f,
            n = y(j.y);
        x.lineTo(k, n);
        x.closePath();
        r -= u / -50;
        x.fillStyle = '#' + (v(r) * 127 + 128 << 16 | v(r + u / 3) * 127 + 128 << 8 | v(r + u / 3 * 2) * 127 + 128).toString(16);
        x.fill();
        q[0] = q[1];
        q[1] = {
          x: k,
          y: n
        };
      }

      function y(p) {
        var t = p + (z() * 2 - 1.1) * f;
        return t > h || t < 0 ? y(p) : t;
      }
      document.onclick = i;
      document.ontouchstart = i;
      i();
    },

    // https://zhuanlan.zhihu.com/api/columns/mapworld
    initHttpQuest: function initHttpQuest() {
      // debugger
      // var htmlobj = $.ajax({
      //   url: "https://zhuanlan.zhihu.com/api/columns/mapworld",
      //   async: false,
      //   dataType: 'jsonp',
      //   success: function (data) {
      //     debugger
      //     var data = data;
      //   }
      // });
    },
    toMapView: function toMapView() {
      this.$router.push({
        name: "mapHome"
      });
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapGaode',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var mymap = L.map('myMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}', {
        attribution: '铿锵侠 &copy; 高德地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "1234"
      }).addTo(mymap);
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapGoogle',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var mymap = L.map('myMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://mt{s}.google.cn/vt/lyrs=m&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}', {
        attribution: '铿锵侠 &copy; 谷歌地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "123"
      }).addTo(mymap);
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapHome',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.init();
  },

  watch: {},
  methods: {
    // 初始化
    init: function init() {
      this.$Notice.destroy();
      var map = L.map('map', {
        scrollWheelZoom: false,
        zoomControl: false,
        attributionControl: false
      });
      var layer = Tangram.leafletLayer({
        scene: '../../../static/lib/scene.yaml'
      });
      layer.addTo(map);
      map.setView([39.916042, 116.390694], 13);
    },
    toMapUseView: function toMapUseView() {
      this.$router.push({
        name: "mapUseView"
      });
    },
    toMapUseTangram: function toMapUseTangram() {
      this.$router.push({
        name: "mapUseTangram"
      });
    },
    toMapUseOlayer: function toMapUseOlayer() {
      this.$router.push({
        name: "mapUseOpenlayer"
      });
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapOpenStreet',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var mymap = L.map('myMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '铿锵侠 ©OpenStreetMap'
      }).addTo(mymap);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapGaode',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var mymap = L.map('myMap', {
        center: [40.7573046875, -73.9599609375],
        zoom: 11,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://localhost:8080/geoserver/gwc/service/wmts?layer=tiger%3Apoly_landmarks&style&tilematrixset=EPSG%3A4326&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A4326%3A{z}&TileCol={x}&TileRow={y}', {
        attribution: '铿锵侠 &copy; 谷歌地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "123"
      }).addTo(mymap);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapTencent',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var mymap = L.map('myMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://rt{s}.map.gtimg.com/realtimerender?z={z}&x={x}&y={y}&type=vector&style=0', {
        tms: true,
        attribution: '铿锵侠 &copy; 腾讯地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "123"
      }).addTo(mymap);
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapUseOpenlayer',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initLeaflet();
  },

  watch: {},
  methods: {
    initLeaflet: function initLeaflet() {
      var map = new ol.Map({
        target: 'map',
        layers: [new ol.layer.Tile({
          source: new ol.source.OSM()
        })],
        view: new ol.View({
          center: ol.proj.fromLonLat([37.41, 8.82]),
          zoom: 4
        })
      });
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapUseTangram',
  data: function data() {
    return {
      watchJSON: CONFIG.GeoJSON
    };
  },

  computed: {},
  mounted: function mounted() {
    // this.initLeaflet();
    // this.initMap();
    this.initMap1();
  },

  watch: {
    watchJSON: {
      handler: function handler(val, oldVal) {
        debugger;
      },
      deep: true
    }
  },
  methods: {
    initLeaflet: function initLeaflet() {
      // debugger
      var map = L.map('map', {
        language: 'cn'
      });
      map.setView([40.7373046875, -73.9599609375], 11);
      var geojsonURL = 'http://localhost:8080/geoserver/gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=tiger:poly_landmarks&STYLE=&TILEMATRIX=EPSG:4326:{z}&TILEMATRIXSET=EPSG:4326&FORMAT=application/json;type=geojson&TILECOL={x}&TILEROW={y}';
      var options = {
        map: map
      };
      var data = new L.tilegeojson(geojsonURL, options);
      debugger;
      map.addLayer(data);

      // data.geojsonLayer.addTo(map);
      // ______________________________________________________________________________________________________________________________________________________________________________
      var bb = {
        "water": {
          "type": "FeatureCollection",
          "totalFeatures": "unknown",
          "features": [{
            "type": "Feature",
            "id": "poly_landmarks.3",
            "geometry": {
              "type": "MultiPolygon",
              "coordinates": [[[[-73.943591, 40.782784], [-73.94143, 40.784761], [-73.939598, 40.785513], [-73.935602, 40.783184], [-73.931106, 40.78215], [-73.928013, 40.780396], [-73.927213, 40.780466], [-73.923377, 40.783822], [-73.920377, 40.789522], [-73.914877, 40.793522], [-73.914677, 40.794422], [-73.916479, 40.797893], [-73.918606, 40.79908], [-73.912506, 40.79618], [-73.910551, 40.790988], [-73.913414, 40.78886], [-73.915358, 40.788096], [-73.918172, 40.784592], [-73.924605, 40.779434], [-73.926006, 40.77888], [-73.92797, 40.776762], [-73.931823, 40.777049], [-73.931857, 40.778263], [-73.934114, 40.777576], [-73.935087, 40.779266], [-73.937312, 40.780657], [-73.937601, 40.78179], [-73.939625, 40.781631], [-73.943591, 40.782784]]], [[[-73.947192, 40.763397], [-73.946405, 40.764298], [-73.945443, 40.763397], [-73.947192, 40.763397]]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.5",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.988779, 40.781822], [-73.985203, 40.785983], [-73.982387, 40.790914], [-73.965367, 40.813606], [-73.964388, 40.815527], [-73.962079, 40.818091], [-73.960738, 40.81756], [-73.960638, 40.815913], [-73.966577, 40.80829], [-73.968092, 40.804722], [-73.973218, 40.798595], [-73.974269, 40.796523], [-73.9759, 40.79554], [-73.976605, 40.793352], [-73.980589, 40.789889], [-73.98154, 40.786186], [-73.984654, 40.783199], [-73.985688, 40.78032], [-73.987439, 40.781], [-73.987134, 40.781394], [-73.987768, 40.781914], [-73.988779, 40.781822]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.6",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.981464, 40.767774], [-73.981131, 40.769272], [-73.958428, 40.800425], [-73.957885, 40.800588], [-73.94954, 40.797003], [-73.973251, 40.764389], [-73.981464, 40.767774]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.10",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.926377, 40.87822], [-73.932477, 40.87042], [-73.938081, 40.874699], [-73.933406, 40.882078], [-73.924506, 40.878978], [-73.926377, 40.87822]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.11",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.949052, 40.836609], [-73.94604, 40.844786], [-73.946923, 40.847753], [-73.947003, 40.850744], [-73.942946, 40.849912], [-73.942256, 40.849152], [-73.942306, 40.848016], [-73.94456, 40.840859], [-73.945997, 40.839843], [-73.948555, 40.83636], [-73.949052, 40.836609]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.12",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.937431, 40.857589], [-73.934881, 40.860276], [-73.93481, 40.861264], [-73.933368, 40.863021], [-73.931761, 40.86682], [-73.93113, 40.867114], [-73.929466, 40.866169], [-73.927017, 40.865683], [-73.929676, 40.863634], [-73.929662, 40.862448], [-73.930981, 40.859554], [-73.931826, 40.859722], [-73.933267, 40.857196], [-73.934165, 40.857091], [-73.933749, 40.858251], [-73.934495, 40.859566], [-73.936713, 40.857281], [-73.937431, 40.857589]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.13",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.932477, 40.87042], [-73.926377, 40.87822], [-73.922519, 40.877492], [-73.921865, 40.876505], [-73.922295, 40.874866], [-73.920686, 40.873271], [-73.919701, 40.873829], [-73.920624, 40.875697], [-73.91774, 40.874555], [-73.91877, 40.873295], [-73.918294, 40.873047], [-73.919558, 40.872162], [-73.919347, 40.871206], [-73.920787, 40.869943], [-73.926655, 40.868086], [-73.92842, 40.866874], [-73.932477, 40.87042]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.14",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.988779, 40.781822], [-73.989778, 40.780323], [-73.992178, 40.780223], [-73.989579, 40.780123], [-73.990479, 40.778923], [-73.992378, 40.778523], [-73.990878, 40.778323], [-73.992878, 40.777823], [-73.991678, 40.777823], [-73.991878, 40.777523], [-73.993278, 40.777423], [-73.992278, 40.777023], [-73.992178, 40.776423], [-73.993478, 40.776423], [-73.993778, 40.776223], [-73.992378, 40.776123], [-73.993978, 40.775823], [-73.994278, 40.775323], [-73.992878, 40.775423], [-73.993879, 40.773223], [-73.996779, 40.774422], [-73.990979, 40.782722], [-73.988779, 40.781822]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.18",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.964928, 40.808433], [-73.963072, 40.811013], [-73.962055, 40.810631], [-73.963956, 40.808002], [-73.964928, 40.808433]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.19",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.964392, 40.807411], [-73.962055, 40.810631], [-73.959223, 40.809403], [-73.96204, 40.805559], [-73.964894, 40.806754], [-73.964392, 40.807411]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.20",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.943529, 40.83916], [-73.943837, 40.838486], [-73.945997, 40.839843], [-73.94456, 40.840859], [-73.943133, 40.840212], [-73.943529, 40.83916]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.21",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.949725, 40.832675], [-73.949392, 40.834008], [-73.948697, 40.83422], [-73.945887, 40.832778], [-73.94687, 40.831431], [-73.949725, 40.832675]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.22",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.94687, 40.831431], [-73.945887, 40.832778], [-73.943031, 40.831632], [-73.944058, 40.830285], [-73.94687, 40.831431]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.23",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.935747, 40.835181], [-73.93884, 40.832705], [-73.940285, 40.83047], [-73.940166, 40.832116], [-73.937787, 40.834858], [-73.936315, 40.838131], [-73.93492, 40.839312], [-73.935709, 40.841554], [-73.930526, 40.848683], [-73.929552, 40.848301], [-73.927238, 40.850912], [-73.926864, 40.851701], [-73.927313, 40.852756], [-73.924185, 40.85706], [-73.92485, 40.858298], [-73.927308, 40.857902], [-73.924373, 40.861754], [-73.922697, 40.859163], [-73.923157, 40.854965], [-73.929808, 40.845552], [-73.931587, 40.841754], [-73.935747, 40.835181]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.24",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.943133, 40.840212], [-73.942384, 40.842186], [-73.939766, 40.841107], [-73.941122, 40.839168], [-73.943133, 40.840212]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.25",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.933006, 40.835679], [-73.934744, 40.835866], [-73.933969, 40.837729], [-73.920571, 40.85821], [-73.921071, 40.860195], [-73.91938, 40.859006], [-73.914925, 40.863713], [-73.914397, 40.865334], [-73.911161, 40.868936], [-73.910646, 40.87264], [-73.911472, 40.873424], [-73.910702, 40.874042], [-73.908605, 40.871678], [-73.909105, 40.871678], [-73.909805, 40.868278], [-73.914105, 40.862778], [-73.920006, 40.856679], [-73.923906, 40.850479], [-73.928106, 40.845579], [-73.930157, 40.841664], [-73.930606, 40.839679], [-73.933006, 40.835679]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.26",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.938808, 40.786872], [-73.935244, 40.791913], [-73.92957, 40.794424], [-73.928643, 40.798852], [-73.930021, 40.803195], [-73.932989, 40.807463], [-73.934213, 40.81133], [-73.933758, 40.817238], [-73.933919, 40.823576], [-73.935194, 40.832399], [-73.934744, 40.835866], [-73.933006, 40.835679], [-73.933306, 40.831379], [-73.933006, 40.828279], [-73.932506, 40.827779], [-73.932106, 40.819479], [-73.932506, 40.811579], [-73.931706, 40.807979], [-73.927206, 40.802179], [-73.922306, 40.802179], [-73.918606, 40.79908], [-73.923518, 40.801571], [-73.926267, 40.801543], [-73.927429, 40.800276], [-73.927821, 40.798175], [-73.927416, 40.796474], [-73.930598, 40.791457], [-73.933094, 40.789645], [-73.933695, 40.789743], [-73.933692, 40.788942], [-73.936384, 40.785828], [-73.936573, 40.784143], [-73.939598, 40.785513], [-73.938808, 40.786872]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.27",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.94981, 40.817887], [-73.948001, 40.819593], [-73.947937, 40.821173], [-73.947273, 40.821748], [-73.946149, 40.821251], [-73.948696, 40.815709], [-73.950968, 40.812604], [-73.951724, 40.812985], [-73.949648, 40.815943], [-73.950119, 40.817015], [-73.94981, 40.817887]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.28",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.942793, 40.805775], [-73.941193, 40.805127], [-73.942985, 40.802581], [-73.946206, 40.803975], [-73.944414, 40.806456], [-73.942793, 40.805775]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.29",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.976565, 40.780638], [-73.974514, 40.783349], [-73.971899, 40.782105], [-73.973776, 40.779427], [-73.976565, 40.780638]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.30",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.954438, 40.795944], [-73.954597, 40.796527], [-73.953509, 40.796886], [-73.951597, 40.79608], [-73.951259, 40.795422], [-73.953013, 40.793833], [-73.953266, 40.795842], [-73.954438, 40.795944]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.31",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.962196, 40.773725], [-73.961672, 40.774448], [-73.960029, 40.773751], [-73.960596, 40.773028], [-73.962196, 40.773725]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.34",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.9526, 40.792419], [-73.952142, 40.79306], [-73.950477, 40.792329], [-73.951023, 40.79164], [-73.9526, 40.792419]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.35",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.954937, 40.789199], [-73.953496, 40.791154], [-73.951919, 40.790374], [-73.953294, 40.788551], [-73.954937, 40.789199]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.36",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.946663, 40.784922], [-73.945724, 40.786171], [-73.943325, 40.785207], [-73.944264, 40.783926], [-73.946663, 40.784922]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.37",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.959805, 40.794313], [-73.961431, 40.79419], [-73.962012, 40.794608], [-73.960787, 40.794616], [-73.959805, 40.794313]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.39",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.944694, 40.773355], [-73.945882, 40.773869], [-73.942525, 40.778155], [-73.942217, 40.777864], [-73.944162, 40.773041], [-73.944694, 40.773355]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.42",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.908584, 40.87761], [-73.90782, 40.877201], [-73.908664, 40.876668], [-73.908976, 40.877223], [-73.908584, 40.87761]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.48",
            "geometry": {
              "type": "MultiPolygon",
              "coordinates": [[[[-74.009318, 40.763397], [-74.009184, 40.763601], [-74.008594, 40.763397], [-74.009318, 40.763397]]], [[[-74.004761, 40.763397], [-73.996779, 40.774422], [-73.994179, 40.773122], [-73.994379, 40.772722], [-73.996779, 40.773722], [-73.994879, 40.772122], [-73.997179, 40.773022], [-73.997379, 40.772722], [-73.995279, 40.771722], [-73.997779, 40.772122], [-73.995679, 40.771122], [-73.995979, 40.770822], [-73.998079, 40.771722], [-73.998279, 40.771422], [-73.996379, 40.770522], [-73.998779, 40.770922], [-73.996679, 40.769722], [-73.997279, 40.769022], [-73.999679, 40.769922], [-73.999879, 40.769522], [-73.996679, 40.768222], [-73.997279, 40.767322], [-74.000879, 40.768322], [-73.997579, 40.766922], [-73.997879, 40.766422], [-73.998279, 40.766022], [-74.001479, 40.767322], [-73.998679, 40.765622], [-73.999079, 40.764922], [-74.002179, 40.766222], [-74.002479, 40.765722], [-73.999779, 40.764522], [-74.000265, 40.763799], [-74.003179, 40.764822], [-74.003379, 40.764522], [-74.001179, 40.763522], [-74.001279, 40.763397], [-74.002865, 40.763397], [-74.003979, 40.763722], [-74.003264, 40.763397], [-74.004761, 40.763397]]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.51",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.969712, 40.779694], [-73.969342, 40.780083], [-73.967842, 40.779351], [-73.968001, 40.779135], [-73.969712, 40.779694]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.56",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.932477, 40.87042], [-73.932868, 40.869608], [-73.93227, 40.869311], [-73.933443, 40.867274], [-73.933142, 40.867074], [-73.938218, 40.859942], [-73.944795, 40.852185], [-73.947003, 40.850744], [-73.952019, 40.851645], [-73.938081, 40.874699], [-73.932477, 40.87042]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.57",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.965092, 40.824483], [-73.963182, 40.8269], [-73.952019, 40.851645], [-73.947003, 40.850744], [-73.946923, 40.847753], [-73.94604, 40.844786], [-73.949294, 40.836721], [-73.949548, 40.836232], [-73.950138, 40.836368], [-73.949787, 40.835553], [-73.950568, 40.835798], [-73.949898, 40.835263], [-73.954662, 40.828512], [-73.955217, 40.826422], [-73.959011, 40.821153], [-73.960724, 40.82188], [-73.959391, 40.820941], [-73.959766, 40.820578], [-73.961231, 40.821217], [-73.960099, 40.820417], [-73.960571, 40.820068], [-73.961734, 40.820664], [-73.960699, 40.819876], [-73.961063, 40.819509], [-73.962232, 40.820213], [-73.96131, 40.819338], [-73.962384, 40.818449], [-73.96813, 40.820631], [-73.965092, 40.824483]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.58",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.953827, 40.763397], [-73.948278, 40.769522], [-73.944162, 40.773041], [-73.942217, 40.777864], [-73.943708, 40.781509], [-73.943591, 40.782784], [-73.939625, 40.781631], [-73.937601, 40.78179], [-73.937312, 40.780657], [-73.93508, 40.779218], [-73.934971, 40.778438], [-73.938399, 40.774606], [-73.938447, 40.77355], [-73.938075, 40.77255], [-73.93519, 40.771745], [-73.935741, 40.770548], [-73.940844, 40.767399], [-73.944803, 40.763397], [-73.945443, 40.763397], [-73.946405, 40.764298], [-73.943478, 40.768322], [-73.940478, 40.770622], [-73.940057, 40.773103], [-73.941534, 40.773545], [-73.9449, 40.770558], [-73.948025, 40.766324], [-73.950532, 40.764142], [-73.951145, 40.763397], [-73.953827, 40.763397]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.60",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.960181, 40.804762], [-73.957337, 40.80943], [-73.957138, 40.810121], [-73.958218, 40.810668], [-73.957825, 40.811276], [-73.9551, 40.810147], [-73.958377, 40.805646], [-73.958261, 40.803142], [-73.959659, 40.801236], [-73.961107, 40.801883], [-73.960181, 40.804762]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.61",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-74.009184, 40.763601], [-74.000426, 40.775735], [-73.996779, 40.774422], [-74.004761, 40.763397], [-74.008594, 40.763397], [-74.009184, 40.763601]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.63",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.964305, 40.783437], [-73.965668, 40.784258], [-73.96496, 40.78709], [-73.959489, 40.787769], [-73.958961, 40.78554], [-73.96158, 40.78197], [-73.962404, 40.782012], [-73.964305, 40.783437]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.64",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.972674, 40.775691], [-73.970492, 40.776121], [-73.970812, 40.774783], [-73.969666, 40.775404], [-73.969456, 40.774907], [-73.970825, 40.774023], [-73.971896, 40.774367], [-73.971861, 40.775285], [-73.97348, 40.774955], [-73.973389, 40.777491], [-73.971999, 40.778154], [-73.971667, 40.776989], [-73.972674, 40.775691]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.65",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.967494, 40.773596], [-73.967842, 40.773873], [-73.967272, 40.774268], [-73.967092, 40.77403], [-73.967494, 40.773596]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.79",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.988779, 40.781822], [-73.990979, 40.782722], [-73.996779, 40.774422], [-74.000426, 40.775735], [-73.96813, 40.820631], [-73.962079, 40.818091], [-73.982387, 40.790914], [-73.985203, 40.785983], [-73.988779, 40.781822]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }, {
            "type": "Feature",
            "id": "poly_landmarks.80",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-73.939885, 40.846674], [-73.940434, 40.845506], [-73.942533, 40.846403], [-73.94209, 40.84785], [-73.939686, 40.847381], [-73.939885, 40.846674]]]
            },
            "geometry_name": "the_geom",
            "properties": {
              "source": "openstreetmapdata.com",
              "kind": "ocean",
              "name": "",
              "area": 7412980745,
              "sort_rank": 200,
              "min_zoom": 0
            }
          }]
        }
      };
      // var cc = {
      //   cameras: {
      //     camera1: {
      //       type: 'perspective'
      //     }
      //   },
      //   lights: {
      //     light1: {
      //       type: 'directional',
      //       direction: [0, 1, '-.5'],
      //       diffuse: 0.3,
      //       ambient: 1
      //     }
      //   },
      //   sources: {
      //     mapzen: {
      //       type: 'GeoJSON',
      //       url: bb,
      //       max_zoom: 16
      //     }
      //   },
      //   layers: {
      //     water: {
      //       data: {
      //         source: 'mapzen'
      //       },
      //       draw: {
      //         polygons: {
      //           order: 'function() { return feature.sort_rank; }',
      //           color: '#88bbee'
      //         }
      //       }
      //     }
      //   }
      // };
      // debugger
      // var map = L.map('map', {
      //   crs: L.CRS.EPSG3857,
      // });
      // map.setView([40.7373046875, -73.9599609375], 10);
      // var layer = Tangram.leafletLayer({
      //   scene: "../static/scene.yaml",
      //   // data: cc,
      //   zIndex: 3,
      // });

      // layer.scene.subscribe({
      //   load: () => {
      //     layer.scene.setDataSource('osm', {
      //       type: 'GeoJSON',
      //       data: bb
      //     });
      //   },
      //   view_complete: () => {}
      // });
      // layer.addTo(map);

      // window.map = map;

      // ______________________________________________________________________________________________________________________________________________________________________________
      // map.setView([62.8089924878968, 32.5551346504404], 11);
    },
    initMap: function initMap() {

      var map = L.map('map');
      var layer = Tangram.leafletLayer({
        scene: {
          cameras: {
            camera1: {
              type: "perspective"
            }
          },
          lights: {
            light1: {
              type: "directional",
              direction: [0, 1, "-.5"],
              diffuse: 0.3,
              ambient: 1
            }
          },
          sources: {
            mapzen: {
              type: "TopoJSON",
              url: "https://tile.mapzen.com/mapzen/vector/v1/all/{z}/{x}/{y}.topojson",
              url_params: {
                api_key: "mapzen-tDHBHDp"
              },
              max_zoom: 16
            }
          },
          layers: {
            earth: {
              data: {
                source: "osm"
              },
              draw: {
                polygons: {
                  order: "function() { return feature.sort_rank; }",
                  color: "#ff00ff"
                }
              }
            }
          }
        }
      });
      layer.scene.subscribe({
        load: function load() {
          layer.scene.setDataSource('osm', {
            type: 'TopoJSON',
            url: 'https://tile.mapzen.com/mapzen/vector/v1/all/{z}/{x}/{y}.topojson',
            url_params: {
              api_key: "mapzen-tDHBHDp"
            }
          });
        },
        view_complete: function view_complete() {}
      });
      layer.addTo(map);
      map.setView([40.70531887544228, -74.00976419448853], 15);
    },
    initMap1: function initMap1() {
      var map = L.map('map', {
        crs: L.CRS.EPSG3857
      });
      var layer = Tangram.leafletLayer({
        scene: '../static/scene.yaml'
      });
      layer.addTo(map);
      map.setView([40.7373046875, -73.9599609375], 12);
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapUseView',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    this.initGaode();
    this.initTencent();
    this.initGoogle();
    this.initOpen();
  },

  watch: {},
  methods: {
    initOpen: function initOpen() {
      var openMap = L.map('openMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '铿锵侠 ©OpenStreetMap'
      }).addTo(openMap);

      var osm4 = new L.TileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        minZoom: 0,
        maxZoom: 13,
        attribution: "osmAttrib"
      });
      var miniMap = new L.Control.MiniMap(osm4).addTo(openMap);

      var osm2 = new L.TileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        minZoom: 0,
        maxZoom: 13,
        attribution: "osmAttrib"
      });
      var miniMap = new L.Control.MiniMap(osm2, {
        toggleDisplay: true
      }).addTo(openMap);
    },
    initGaode: function initGaode() {
      var gaodeMap = L.map('gaodeMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      var url = 'http://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}';
      L.tileLayer(url, {
        attribution: '铿锵侠 &copy; 高德地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "1234"
      }).addTo(gaodeMap);
    },
    initTencent: function initTencent() {
      var tencentMap = L.map('tencentMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://rt{s}.map.gtimg.com/realtimerender?z={z}&x={x}&y={y}&type=vector&style=0', {
        tms: true,
        attribution: '铿锵侠 &copy; 腾讯地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "123"
      }).addTo(tencentMap);
    },
    initGoogle: function initGoogle() {
      var googleMap = L.map('googleMap', {
        center: [39.916042, 116.390694],
        zoom: 14,
        fullscreenControl: {
          pseudoFullscreen: true
        }
      });
      L.tileLayer('http://mt{s}.google.cn/vt/lyrs=m&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}', {
        attribution: '铿锵侠 &copy; 谷歌地图',
        maxZoom: 18,
        minZoom: 9,
        subdomains: "123"
      }).addTo(googleMap);
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d62ce86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(72),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42b34bb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-812419d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25ca7f86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-343b4acb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15d08134",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(76),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bfe0a552",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(75),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9ebac744",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ff493cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(73),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4eee1144",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myMap"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-1"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("地图列表")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "Leaflet 类库包",
      "placement": "right"
    }
  }, [_c('div', {
    staticClass: "maplist",
    on: {
      "click": _vm.toMapUseView
    }
  }, [_vm._v("地图浏览")])]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "Tangram 插件",
      "placement": "right"
    }
  }, [_c('div', {
    staticClass: "maplist",
    on: {
      "click": _vm.toMapUseTangram
    }
  }, [_vm._v("Tangram试验")])]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "OpenLayers 类库包",
      "placement": "right"
    }
  }, [_c('div', {
    staticClass: "maplist",
    on: {
      "click": _vm.toMapUseOlayer
    }
  }, [_vm._v("OpenLayers试验")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("铿锵侠")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("一个目前在帝都的GISer。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "width": "300px",
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_vm._v("程序员里地图画的很好，画地图里文章写得很棒，写文章里编程编的不错。就是这么一个人。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-1"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "知乎主页",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://www.zhihu.com/people/kengqiangxia",
      "target": "_blank"
    }
  }, [_vm._v("铿锵侠")])]), _vm._v(" "), _c('div', [_vm._v("知乎专栏")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "科普为主，适合所有人阅读",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://zhuanlan.zhihu.com/mapworld",
      "target": "_blank"
    }
  }, [_vm._v("《地图看世界》")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "技术为主，适合GIS初学者阅读",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://zhuanlan.zhihu.com/GISDevelop",
      "target": "_blank"
    }
  }, [_vm._v("《GIS开发从入门到放弃》")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "欢迎扫描二维码，添加关注",
      "placement": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d8cf0",
      "cursor": "pointer",
      "width": "100px",
      "text-align": "center"
    },
    on: {
      "click": _vm.toMapView
    }
  }, [_vm._v("mapsworld")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', [_c('Icon', {
    attrs: {
      "type": "map"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("地图应用")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d8cf0",
      "cursor": "pointer",
      "width": "100px",
      "text-align": "center"
    },
    on: {
      "click": _vm.toMapView
    }
  }, [_vm._v("地图列表")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://shop113148564.taobao.com",
      "target": "_blank"
    }
  }, [_vm._v("地图看世界周边")])], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "home-cartoon"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("知乎主页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-3"
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信公众号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("淘宝店")])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("OpenStreetMap")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "myMap"
    }
  })])])
}]}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("Tangram")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
}]}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("高德地图")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "myMap"
    }
  })])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('Tabs', {
    staticStyle: {
      "margin": "30px",
      "color": "white"
    },
    attrs: {
      "value": "name1"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "OpenStreetMap",
      "name": "name1",
      "icon": "map"
    }
  }, [_c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "openMap"
    }
  })])]), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "高德地图",
      "name": "name2",
      "icon": "map"
    }
  }, [_c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "gaodeMap"
    }
  })])]), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "腾讯地图",
      "name": "name3",
      "icon": "map"
    }
  }, [_c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "tencentMap"
    }
  })])]), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "GoogleMap",
      "name": "name4",
      "icon": "map"
    }
  }, [_c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "googleMap"
    }
  })])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("谷歌地图")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "myMap"
    }
  })])])
}]}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("OpenLayers")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maphome"
    }
  }, [_c('div', {
    attrs: {
      "id": "headText"
    }
  }, [_vm._v("腾讯地图")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapcontent"
    }
  }, [_c('div', {
    attrs: {
      "id": "myMap"
    }
  })])])
}]}

/***/ })
],[40]);


// WEBPACK FOOTER //
// static/js/app.9c6eab1260d270e3e3f4.js